import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';

import { SnTag, SnLocation, SnContentType } from '@lib/api/entities';
import { SnLocationsAPI } from '@lib/api/services';
import { snFadeIn, snFadeOut } from '@lib/common/animations';

@Component({
  selector: 'sn-location-details',
  templateUrl: './location-details.component.html',
  styleUrls: ['./location-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [snFadeIn, snFadeOut],
})
export class LocationDetailsComponent implements OnDestroy {
  @Input() public location: SnLocation;

  public readonly tagContentType = SnContentType.Location;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _locationsAPI: SnLocationsAPI,
    private readonly _changeDetectorRef: ChangeDetectorRef,
  ) {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onTagsChanged(tags: SnTag[]): void {
    this._locationsAPI
      .updateLocation(this.location.id, { tags })
      .pipe(takeUntil(this._destroy$))
      .subscribe((location: SnLocation) => {
        this.location.tags = location.tags;
        this._changeDetectorRef.detectChanges();
      });
  }
}
